import { ArrowDownIcon, ArrowRightIcon } from "@heroicons/react/solid";
import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
    return (
        <header className="bg-gray-800 md:sticky top-0 z-10 bg-navColor">
            <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">

                <a className="title-font font-medium text-white mb-4 md:mb-0">
                    <a href="/" className="ml-3 text-xl">
                        Rahul Dhar Roni
                    </a>
                </a>
                {/* dropdown start */}
                <div class="dropdown">
                    <label tabindex="0" class="btn btn-ghost lg:hidden text-white">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabindex="0" class="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-200 rounded-box w-52">
                        <li><a href="#projects" className="mr-5 hover:text-white">
                            Past Work
                        </a></li>
                        <li><a href="#skills" className="mr-5 hover:text-white">
                            Skills
                        </a></li>
                        <li><a href="#testimonials" className="mr-5 hover:text-white">
                            Testimonials
                        </a></li>
                        <li><a href="#aboutMe" className="mr-5 hover:text-white">
                            About Me
                        </a></li>
                        <li><Link id="#blog" to='/blog'>Blog</Link></li>
                    </ul>
                </div>
                {/* dropdown end */}
                <nav className="invisible md:visible md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700	flex flex-wrap items-center text-base justify-center">
                    <a href="#projects" className="mr-5 text-slate-500  hover:text-white">
                        Past Work
                    </a>
                    <a href="#skills" className="mr-5 text-slate-500 hover:text-white">
                        Skills
                    </a>
                    <a href="#testimonials" className="mr-5 text-slate-500 hover:text-white">
                        Testimonials
                    </a>
                    <Link to='/blog' className="text-slate-500  hover:text-white">Blog</Link>
                </nav>
                <a href='https://drive.google.com/file/d/1iKzoMX0Vjlmu8s3Vf7OSlgBQK1moVOsA/view?usp=sharing' className="inline-flex items-center text-slate-500  bg-gray-800 border-0 py-1 px-3 focus:outline-none hover:bg-gray-700 rounded text-base mt-4 md:mt-0" download>Download Resume <ArrowDownIcon className="w-4 h-4 ml-1" /></a>

                <a
                    href="#contact"
                    className="inline-flex items-center text-slate-500  bg-gray-800 border-0 py-1 px-3 focus:outline-none hover:bg-gray-700 rounded text-base mt-4 md:mt-0">
                    Hire Me
                    <ArrowRightIcon className="w-4 h-4 ml-1" />
                </a>
            </div>
        </header>
    );
}

export default Navbar;